var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.70711 0.292893C6.09763 0.683417 6.09763 1.31658 5.70711 1.70711L4.41421 3H13C15.7614 3 18 5.23858 18 8C18 10.7614 15.7614 13 13 13H1C0.447715 13 0 12.5523 0 12C0 11.4477 0.447715 11 1 11H13C14.6569 11 16 9.65685 16 8C16 6.34315 14.6569 5 13 5H4.41421L5.70711 6.29289C6.09763 6.68342 6.09763 7.31658 5.70711 7.70711C5.31658 8.09763 4.68342 8.09763 4.29289 7.70711L1.29289 4.70711C0.902369 4.31658 0.902369 3.68342 1.29289 3.29289L4.29289 0.292893C4.68342 -0.0976311 5.31658 -0.0976311 5.70711 0.292893Z",
    fill: "var(--grey-500)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow-back.ca48b225cd4406288ae447b47545a74c.svg";
export { ForwardRef as ReactComponent };